//@ts-nocheck
import React, { useEffect, useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import {
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { classNames } from "../../../utils/classNames";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGetHook from "../../../customHooks/useGetHook";
import CreateIcon from "../../../Icons/CreateIcon";
import Spinner from "../Spinner";
import { useDebounce } from "../../../customHooks/useDebounceHook";
//@ts-ignore
import { useDownload } from "@careinfo/layout";
import { TableSettingsLayout } from "@careinfo/layout";
import DownloadIcon from "../../../Icons/DownloadIcon";
import moment from "moment";
import { toast } from "react-toastify";
import Template from "../DataTable/loading";
import { useVirtualizer } from "@tanstack/react-virtual";

interface IDataTable {
  url: string;
  queryKey: string;
  columns: any;
  setOrderData?: any;
  addNewPagePath?: string;
  tableName: string;
  params?: any;
  scanComponent?: any;
  actionMenu?: any;
  setRerender?: any;
  isUpload?: boolean;
  orderSearch?: boolean;
  isDownload?: boolean;
  handleRowClick?: (any) => void;
}

function InvoiceDataTable(props: IDataTable) {
  const {
    url,
    queryKey,
    columns,
    addNewPagePath,
    scanComponent,
    tableName,
    actionMenu,
    setOrderData = () => {},
    params: otherParams,
    isUpload = false,
    orderSearch = false,
    isDownload = false,
    handleRowClick,
  } = props;
  const [searchParams, setSearchParms] = useSearchParams({
    limit: "10",
    page: "0",
    searchQuery: "",
  });
  const [limit, setLimit] = useState(10);
  const page = parseInt(searchParams.get("page") ?? "0");
  const searchQuery = searchParams.get("searchQuery");
  const selectedItems = searchParams.get("selectedItems");
  const navigate = useNavigate();
  const debounceSearch = useDebounce(searchQuery);
  const [isOpenTableSetting, setIsOpenTableSettings] = useState(false);
  const [countSelectedItems, setSelectedItems] = useState([]);
  const [isactive, setISactive] = useState("invoice");

  useEffect(() => {
    const items = selectedItems?.split(",");
    setSelectedItems(items?.length);
  }, [selectedItems]);

  const fetchParams = {
    limit: limit === "All" ? undefined : limit,
    offset: limit === "All" ? undefined : limit * page,
    ...(isactive === "order"
      ? { order: debounceSearch }
      : { search: debounceSearch }),
    ...otherParams,
  };

  const { data: serverData, isLoading } = useGetHook({
    queryKey: [
      queryKey,
      `${queryKey}-${limit}-${page}-${debounceSearch}-${isactive}-${JSON.stringify(
        otherParams
      )}-${JSON.stringify(fetchParams)}`,
    ],
    url: url,
    params: fetchParams,
  });
  const [data, setData] = useState([]);

  useEffect(() => {
    if (Array.isArray(serverData?.results) && limit !== "All") {
      setData([...serverData?.results] ?? []);
      setOrderData((prev) => {
        const existingIds = new Set(prev.map((item) => item.id));
        const newItems = serverData?.results.filter(
          (item) => !existingIds.has(item.id)
        );
        return [...prev, ...newItems];
      });

      if (searchParams.get("selectAllItems") === "1") {
        const _newItems = serverData?.results
          ?.map(
            (item) =>
              `${item.id}%3Adelivery_charge%3D${item.deliver_charge ?? 0}`
          )
          .join(",");

        const newParams: Record<string, any> = {
          page,
          selectedItems: _newItems,
          selectAllItems: searchParams.get("selectAllItems"),
          searchQuery,
        };

        const existingEditedOrders = searchParams.get("editedOrders");
        if (existingEditedOrders) {
          newParams.editedOrders = existingEditedOrders;
        }

        setSearchParms(newParams);
      }
    } else if (Array.isArray(serverData)) {
      setData([...serverData] ?? []);
      setOrderData((prev) => {
        const existingIds = new Set(prev.map((item) => item.id));
        const newItems = serverData.filter((item) => !existingIds.has(item.id));
        return [...prev, ...newItems];
      });

      if (searchParams.get("selectAllItems") === "1") {
        const _newItems = serverData
          ?.map(
            (item) =>
              `${item.id}%3Adelivery_charge%3D${item.deliver_charge ?? 0}`
          )
          .join(",");

        const newParams: Record<string, any> = {
          page,
          selectedItems: _newItems,
          selectAllItems: searchParams.get("selectAllItems"),
          searchQuery,
        };
        const existingEditedOrders = searchParams.get("editedOrders");
        if (existingEditedOrders) {
          newParams.editedOrders = existingEditedOrders;
        }

        setSearchParms(newParams);
      }
    }
  }, [serverData]);

  const tableContainerRef = React.useRef<HTMLDivElement>(null);
  const table = useReactTable({
    data,
    columns,
    manualPagination: true,
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    debugTable: true,
  });
  const { rows } = table.getRowModel();
  const rowVirtualizer = useVirtualizer({
    count: rows.length,
    estimateSize: () => 80,
    getScrollElement: () => tableContainerRef.current,
    measureElement:
      typeof window !== "undefined" &&
      navigator.userAgent.indexOf("Firefox") === -1
        ? (element) => element?.getBoundingClientRect().height
        : undefined,
    overscan: 5,
  });

  const handleAddPageRoute = () => {
    navigate(addNewPagePath);
  };

  useEffect(() => {
    if (limit !== "All") {
      table.setPageSize(limit);
    }
  }, [limit]);

  const handleNextPage = () => {
    searchParams.set("page", page + 1);
    setSearchParms(searchParams);
  };

  const handlePreviousPage = () => {
    searchParams.set("page", page - 1);
    setSearchParms(searchParams);
  };

  const handleLastpage = () => {
    searchParams.set("page", Math.floor(serverData?.count / limit));
    setSearchParms(searchParams);
  };

  const handleFirstPage = () => {
    searchParams.set("page", 0);
    setSearchParms(searchParams);
  };

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);
    searchParams.set("page", 0);
    setSearchParms(searchParams);
  };

  const { download } = useDownload();

  const handleDownloadExcel = async () => {
    const selectedItemsParam = searchParams.get("selectedItems");
    if (!selectedItemsParam) {
      toast.error("Please select at least one order first");
      return;
    }
    const idsOnly = selectedItemsParam
      .split(",")
      .map((item) => decodeURIComponent(item).split(":")[0])
      .join(",");
    try {
      await download(
        `logisticservice/api/order/download-excel/`,
        `${queryKey}-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`,
        idsOnly
      );
    } catch (err) {
      console.log(err);
    }
  };

  return isLoading ? (
    <Template addNewPath={addNewPagePath} />
  ) : (
    <>
      <div className={tw`w-full flex justify-between`}>
        {addNewPagePath && (
          <div className={tw`flex items-center justify-between`}>
            <button
              onClick={handleAddPageRoute}
              className={tw`p-2 flex gap-x-2 bg-primary-light my-2 rounded text-primary`}
            >
              <CreateIcon color={"var(--primary)"} />
              Add New
            </button>
            {scanComponent}
          </div>
        )}
      </div>
      <div
        className={tw`w-full bg-white rounded-sm mb-8`}
        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        <div
          className={tw`w-full grid grid-cols-1 gap-4 md:flex justify-between px-2`}
        >
          <div className={tw`flex items-center`}>
            <input
              type="text"
              placeholder="Search"
              value={searchQuery ?? ""}
              onChange={(e) => handleSearch(e?.target?.value)}
              className={tw`border w-full border-1 border-primary focus:outline-none p-1`}
            />
          </div>
          <div
            className={tw`text-primary w-full justify-end items-center flex gap-x-4`}
          >
            {countSelectedItems && (
              <div
                className={tw`text-primary gap-x-4 flex items-center justify-end `}
              >
                <span>Selected:{countSelectedItems ?? 0}</span>
                <button
                  className={tw`focus:outline-none px-4  border-1 border-primary rounded-md flex items-center justify-center`}
                  onClick={() => {
                    const clonedParams = new URLSearchParams(searchParams);
                    clonedParams.delete("selectAllItems");
                    clonedParams.delete("selectedItems");
                    setSearchParms(clonedParams);
                  }}
                >
                  Unselect
                </button>
              </div>
            )}
            <span className={tw`flex gap-x-1  cursor-pointer`}>
              {actionMenu}
            </span>
            {isDownload && (
              <span
                className={tw`flex gap-x-1 cursor-pointer`}
                onClick={handleDownloadExcel}
              >
                <DownloadIcon color={"var(--primary)"} />
                <span className={tw`text-primary`}>Download</span>
              </span>
            )}
          </div>
          <div className={tw`flex items-center`}>

          <TableSettingsLayout
            isOpenTableSetting={isOpenTableSetting}
            setIsOpenTableSettings={setIsOpenTableSettings}
            tableName={tableName}
            defaultColumns={columns}
            onSettingsLoaded={(settings) => {
              if (settings?.page_limit != null) {
                setLimit(settings.page_limit);
                searchParams.set("limit", settings.page_limit.toString());
                setSearchParms(searchParams);
              }
            }}
          />
          </div>
        </div>
        <div
          style={{
            overflow: "auto",
            position: "relative",
            minHeight: "100px",
            maxHeight: "calc(100vh - 250px)",
          }}
          ref={tableContainerRef}
        >
          <table className={tw`w-full grid `}>
            <thead
              className={tw`bg-primary grid text-white uppercase sticky top-0 z-[5]  `}
            >
              {table.getHeaderGroups().map((headerGroup) => (
                <tr
                  key={headerGroup.id}
                  className={tw`flex w-full justify-between`}
                >
                  {headerGroup.headers.map((header, index) => (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      style={{
                        width: header.getSize(),
                      }}
                      className={classNames(
                        index === 0
                          ? tw``
                          : headerGroup.headers?.length - 1 === index
                          ? tw` text-left w-[8rem]`
                          : tw``,
                        tw`py-[5px] text-left px-5 whitespace-nowrap flex`
                      )}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody
              style={{
                display: "grid",
                height: `${rowVirtualizer.getTotalSize()}px`, //tells scrollbar how big the table is
                position: "relative", //needed for absolute positioning of rows
              }}
            >
              {rowVirtualizer.getVirtualItems().map((virtualRow) => {
                const row = rows[virtualRow.index] as Row<Person>;
                return (
                  <tr
                    data-index={virtualRow.index}
                    ref={(node) => {
                      if (node) {
                        requestAnimationFrame(() => {
                          rowVirtualizer.measureElement(node);
                        });
                      }
                    }}
                    key={row.id}
                    style={{
                      transform: `translateY(${virtualRow.start}px)`,
                    }}
                    className={tw`even:bg-gray-50 odd:bg-white hover:bg-gray-100 hover:transition-All w-full flex justify-between items-center absolute`}
                    onClick={() => handleRowClick(row)}
                  >
                    {row.getVisibleCells().map((cell) => {
                      return (
                        <td
                          key={cell.id}
                          style={{
                            width: cell.column.getSize(),
                          }}
                          className={tw`py-[10px] text-left px-5 `}
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              {table.getFooterGroups().map((footerGroup) => (
                <tr key={footerGroup.id}>
                  {footerGroup.headers.map((header) => (
                    <th key={header.id} colSpan={header.colSpan}>
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.footer,
                            header.getContext()
                          )}
                    </th>
                  ))}
                </tr>
              ))}
            </tfoot>
          </table>
        </div>
        <div
          className={tw`flex bg-white py-2 my-4 w-full justify-center gap-4`}
        >
          <button
            className={tw`border hidden md:block rounded p-1`}
            onClick={() => handleFirstPage()}
            disabled={!serverData?.previous || limit === "All"}
          >
            {"<<"}
          </button>
          <button
            className={tw`border rounded p-1`}
            onClick={() => handlePreviousPage()}
            disabled={!serverData?.previous || page === 0 || limit === "All"}
          >
            {"<"}
          </button>
          <button
            className={tw`border rounded p-1`}
            onClick={() => handleNextPage()}
            disabled={
              !serverData?.next ||
              page + 1 >= Math.ceil(serverData?.count / limit) ||
              limit === "All"
            }
          >
            {">"}
          </button>
          <button
            className={tw`border hidden md:block rounded p-1`}
            onClick={() => handleLastpage()}
            disabled={!serverData?.next || limit === "All"}
          >
            {">>"}
          </button>
          <span className={tw`flex items-center gap-1`}>
            <div>Page</div>
            <strong>
              {page + 1} of{" "}
              {limit === "All" ? 1 : Math.ceil(serverData?.count / limit)}
            </strong>
          </span>
          <select
            value={limit}
            className={tw`focus:outline-none`}
            onChange={(e) => {
              const newLimit =
                e.target.value === "All" ? "All" : Number(e.target.value);
              setLimit(newLimit);
              if (newLimit === "All") {
                searchParams.delete("limit");
                searchParams.delete("page");
              } else {
                searchParams.set("limit", e.target.value);
                searchParams.set("page", "0");
              }
              setSearchParms(searchParams);
            }}
          >
            {[10, 50, 100, 200, 500, "All"].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
          <p className={tw`mt-1`}>
            All: {serverData?.count ?? serverData?.length}
          </p>
        </div>
      </div>
    </>
  );
}

export default InvoiceDataTable;
